const autocompleteModalFilterEquip = {
  maintenance: 'Equipments under maintenance',
  valid: 'Equipments ready to use',
  validWithOpenedActions: 'Equipments ready but in adequation',
  inactive: 'Inactive equipments',
  invalid: 'Equipments not ready to use',
  inDelay: 'Services in delay',
  notDone: 'Mandatory services not done',
  hasActionsOpenedOrOverdue: 'Services have opened or overdue actions',
  hasNoServices: 'Does not have any service',
  mixed: 'Mixed reasons'
};


export default autocompleteModalFilterEquip;
